import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DateTimePickerComponent } from './datetimepicker.component';
/**
 * NgModule definition for the DateTimePicker component.
 */
export class DateTimePickerModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
    imports: [CommonModule],
    declarations: [
        DateTimePickerComponent
    ],
    exports: [
        DateTimePickerComponent
    ]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function DateTimePickerModule_tsickle_Closure_declarations() {
/** @type {?} */
DateTimePickerModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
DateTimePickerModule.ctorParameters;
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
